<div style="width: 100%" [nbSpinner]="this.isLoading">
  <mat-form-field style="width: 100%">
    <mat-label *ngIf="!isBackupRoom">{{"Room" | tenantWords}}</mat-label>
    <mat-label *ngIf="isBackupRoom">{{"Backup Room" | tenantWords}}</mat-label>
    <mat-select (selectionChange)="this.onSelectChange()" id="select" [required]="this.isRequired" [(ngModel)]="room"
      name="select" #select="ngModel" (ngModelChange)="onSelectChange()">
      <mat-option>
        <ngx-mat-select-search [(ngModel)]="this.searchValue" (ngModelChange)="filter()" placeholderLabel="Find..."
          name="search" #search="ngModel">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngIf="this.objList.length === 0">
        {{this.filterList.length > 50 ? 'Too many rooms found, please narrow your search' : 'No rooms found'}}
      </mat-option>
      <mat-option *ngFor="let x of this.objList" [value]="x">
        <div *ngIf="!this.cropYearId">
          {{x.name}} {{x.warehouse ? '(' + x.warehouse.name + ')' : ""}}
        </div>
        <div *ngIf="this.cropYearId">
          {{x.name}} {{x.warehouse ? ' - ' + x.warehouse.name : ""}} (Available: {{x.remainingSpace | number}})
        </div>

      </mat-option>
    </mat-select>
  </mat-form-field>
  <div [hidden]="select.valid || select.pristine" class="alert alert-danger">
    Room is required
  </div>
</div>